(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["first_releases/calendar.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("layout.html", true, "first_releases/calendar.html", false, function(t_3,t_2) {
if(t_3) { cb(t_3); return; }
parentTemplate = t_2
for(var t_1 in parentTemplate.blocks) {
context.addBlock(t_1, parentTemplate.blocks[t_1]);
}
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("content"))(env, context, frame, runtime, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
output += t_4;
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("sidebar"))(env, context, frame, runtime, function(t_7,t_6) {
if(t_7) { cb(t_7); return; }
output += t_6;
output += "\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_content(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "\r\n<div id=\"calendar\">\r\n    <div id=\"calendar-title\" class=\"title-block\">\r\n        <h1>";
output += runtime.suppressValue(env.getFilter("trans").call(context, "calendar.title"), env.opts.autoescape);
output += "</h1>\r\n    </div>\r\n\r\n    <div id=\"calendar-tools\">\r\n        ";
if(runtime.contextOrFrameLookup(context, frame, "calendar_prev")) {
output += "<a id=\"calendar-prev\" href=\"";
output += runtime.suppressValue((lineno = 9, colno = 58, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["first_releases_calendar",{"year": env.getFilter("date").call(context, runtime.contextOrFrameLookup(context, frame, "calendar_prev"),"Y"),"month": env.getFilter("date").call(context, runtime.contextOrFrameLookup(context, frame, "calendar_prev"),"m")}])), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(env.getFilter("date").call(context, runtime.contextOrFrameLookup(context, frame, "calendar_prev"),runtime.contextOrFrameLookup(context, frame, "formatMonth")), env.opts.autoescape);
output += "</a>";
;
}
output += "\r\n        <span id=\"calendar-act\">";
output += runtime.suppressValue(env.getFilter("date").call(context, runtime.contextOrFrameLookup(context, frame, "calendar_act"),runtime.contextOrFrameLookup(context, frame, "formatMonth")), env.opts.autoescape);
output += "</span>\r\n        ";
if(runtime.contextOrFrameLookup(context, frame, "calendar_next")) {
output += "<a id=\"calendar-next\" href=\"";
output += runtime.suppressValue((lineno = 11, colno = 58, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["first_releases_calendar",{"year": env.getFilter("date").call(context, runtime.contextOrFrameLookup(context, frame, "calendar_next"),"Y"),"month": env.getFilter("date").call(context, runtime.contextOrFrameLookup(context, frame, "calendar_next"),"m")}])), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(env.getFilter("date").call(context, runtime.contextOrFrameLookup(context, frame, "calendar_next"),runtime.contextOrFrameLookup(context, frame, "formatMonth")), env.opts.autoescape);
output += "</a>";
;
}
output += "\r\n    </div>\r\n\r\n    <div id=\"calendar-list\">\r\n        <div id=\"calendar-days\">\r\n            <table>\r\n            <colgroup>\r\n                <col width=\"9%\">\r\n                <col width=\"13%\">\r\n                <col width=\"13%\">\r\n                <col width=\"13%\">\r\n                <col width=\"13%\">\r\n                <col width=\"13%\">\r\n                <col width=\"13%\">\r\n                <col width=\"13%\">\r\n            </colgroup>\r\n            <thead>\r\n                <tr>\r\n                    <th>";
output += runtime.suppressValue(env.getFilter("trans").call(context, "calendar.weekno"), env.opts.autoescape);
output += "</th>\r\n                    <th>";
output += runtime.suppressValue(env.getFilter("trans").call(context, "calendar.day_mon"), env.opts.autoescape);
output += "</th>\r\n                    <th>";
output += runtime.suppressValue(env.getFilter("trans").call(context, "calendar.day_tue"), env.opts.autoescape);
output += "</th>\r\n                    <th>";
output += runtime.suppressValue(env.getFilter("trans").call(context, "calendar.day_wed"), env.opts.autoescape);
output += "</th>\r\n                    <th>";
output += runtime.suppressValue(env.getFilter("trans").call(context, "calendar.day_thu"), env.opts.autoescape);
output += "</th>\r\n                    <th>";
output += runtime.suppressValue(env.getFilter("trans").call(context, "calendar.day_fri"), env.opts.autoescape);
output += "</th>\r\n                    <th>";
output += runtime.suppressValue(env.getFilter("trans").call(context, "calendar.day_sat"), env.opts.autoescape);
output += "</th>\r\n                    <th>";
output += runtime.suppressValue(env.getFilter("trans").call(context, "calendar.day_sun"), env.opts.autoescape);
output += "</th>\r\n                </tr>\r\n            </thead>\r\n            <tbody>\r\n                <tr>\r\n                ";
frame = frame.push();
var t_10 = runtime.contextOrFrameLookup(context, frame, "days");
if(t_10) {t_10 = runtime.fromIterator(t_10);
var t_9 = t_10.length;
for(var t_8=0; t_8 < t_10.length; t_8++) {
var t_11 = t_10[t_8];
frame.set("day", t_11);
frame.set("loop.index", t_8 + 1);
frame.set("loop.index0", t_8);
frame.set("loop.revindex", t_9 - t_8);
frame.set("loop.revindex0", t_9 - t_8 - 1);
frame.set("loop.first", t_8 === 0);
frame.set("loop.last", t_8 === t_9 - 1);
frame.set("loop.length", t_9);
output += "\r\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") % 7 == 0) {
output += "\r\n                        </tr><tr>\r\n                        <th>";
output += runtime.suppressValue(env.getFilter("date").call(context, runtime.memberLookup((t_11),"date"),"W"), env.opts.autoescape);
output += "</th>\r\n                    ";
;
}
output += "\r\n                    <td data-list=\"list-";
output += runtime.suppressValue(env.getFilter("date").call(context, runtime.memberLookup((t_11),"date"),"Ymd"), env.opts.autoescape);
output += "\"";
if(runtime.memberLookup((runtime.memberLookup((t_11),"items")),"length") > 0) {
output += " class=\"has-item";
if(runtime.memberLookup((t_11),"hasReleased")) {
output += " has-released";
;
}
output += "\"";
;
}
output += ">\r\n                        <div class=\"daynumber";
if(runtime.memberLookup((t_11),"outer")) {
output += " outer";
;
}
output += "\">";
output += runtime.suppressValue(env.getFilter("date").call(context, runtime.memberLookup((t_11),"date"),"j"), env.opts.autoescape);
output += "</div>\r\n                    </td>\r\n                ";
;
}
}
frame = frame.pop();
output += "\r\n                </tr>\r\n            </tbody>\r\n            </table>\r\n        </div>\r\n        ";
frame = frame.push();
var t_14 = runtime.contextOrFrameLookup(context, frame, "days");
if(t_14) {t_14 = runtime.fromIterator(t_14);
var t_13 = t_14.length;
for(var t_12=0; t_12 < t_14.length; t_12++) {
var t_15 = t_14[t_12];
frame.set("day", t_15);
frame.set("loop.index", t_12 + 1);
frame.set("loop.index0", t_12);
frame.set("loop.revindex", t_13 - t_12);
frame.set("loop.revindex0", t_13 - t_12 - 1);
frame.set("loop.first", t_12 === 0);
frame.set("loop.last", t_12 === t_13 - 1);
frame.set("loop.length", t_13);
output += "\r\n            ";
if(runtime.memberLookup((runtime.memberLookup((t_15),"items")),"length") > 0) {
output += "\r\n                <ul id=\"list-";
output += runtime.suppressValue(env.getFilter("date").call(context, runtime.memberLookup((t_15),"date"),"Ymd"), env.opts.autoescape);
output += "\" class=\"day";
if(runtime.memberLookup((t_15),"hasReleased")) {
output += " has-released";
;
}
output += "\">\r\n                    <li class=\"weekSep dayDisplay\">\r\n                        <span class=\"item-week\">";
output += runtime.suppressValue(env.getFilter("date").call(context, runtime.memberLookup((t_15),"date"),runtime.contextOrFrameLookup(context, frame, "formatDate")), env.opts.autoescape);
output += "</span>\r\n                    </li>\r\n                    ";
frame = frame.push();
var t_18 = runtime.memberLookup((t_15),"items");
if(t_18) {t_18 = runtime.fromIterator(t_18);
var t_17 = t_18.length;
for(var t_16=0; t_16 < t_18.length; t_16++) {
var t_19 = t_18[t_16];
frame.set("item", t_19);
frame.set("loop.index", t_16 + 1);
frame.set("loop.index0", t_16);
frame.set("loop.revindex", t_17 - t_16);
frame.set("loop.revindex0", t_17 - t_16 - 1);
frame.set("loop.first", t_16 === 0);
frame.set("loop.last", t_16 === t_17 - 1);
frame.set("loop.length", t_17);
output += "\r\n                        ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("first_releases/list_item.html", false, "first_releases/calendar.html", false, function(t_21,t_20) {
if(t_21) { cb(t_21); return; }
callback(null,t_20);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_23,t_22) {
if(t_23) { cb(t_23); return; }
callback(null,t_22);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\r\n                    ";
});
}
}
frame = frame.pop();
output += "\r\n                </ul>\r\n            ";
;
}
output += "\r\n        ";
;
}
}
frame = frame.pop();
output += "\r\n        ";
output += "\r\n    </div>\r\n</div>\r\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_sidebar(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "\r\n    ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("widgets/calendar.html", false, "first_releases/calendar.html", false, function(t_25,t_24) {
if(t_25) { cb(t_25); return; }
callback(null,t_24);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_27,t_26) {
if(t_27) { cb(t_27); return; }
callback(null,t_26);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\r\n\r\n    <div id=\"view-switcher\">\r\n        <p class=\"to-catalog-view\"><a href=\"";
output += runtime.suppressValue((lineno = 77, colno = 48, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["first_releases_index"])), env.opts.autoescape);
output += "\"><img src=\"assets/view_list.png\" alt=\"\"> ";
output += runtime.suppressValue(env.getFilter("trans").call(context, "calendar.switch_to_catalog"), env.opts.autoescape);
output += "</a></p>\r\n    </div>\r\n    \r\n    ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("first_releases/sidebar_order_and_download.html", false, "first_releases/calendar.html", false, function(t_29,t_28) {
if(t_29) { cb(t_29); return; }
callback(null,t_28);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_31,t_30) {
if(t_31) { cb(t_31); return; }
callback(null,t_30);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\r\n    ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("widgets/release_notice.html", false, "first_releases/calendar.html", false, function(t_33,t_32) {
if(t_33) { cb(t_33); return; }
callback(null,t_32);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_35,t_34) {
if(t_35) { cb(t_35); return; }
callback(null,t_34);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\r\n";
cb(null, output);
})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_content: b_content,
b_sidebar: b_sidebar,
root: root
};

})();
})();
